import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsScalaComponent } from './simple-icons-scala.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsScalaComponent ],
    exports:      [ SimpleIconsScalaComponent ],
    bootstrap:    []
})
export class SimpleIconsScalaModule {}
